/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import "./App.scss";
import "antd";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import AuthRouter from "Processes/auth";
import { CheckUserPage } from "Processes/auth/CheckUser/checkUser.page";
import AboutApplicationPage from "Pages/AboutApplication";
import { WithdrawPage } from "Pages/Withdraw";
import { PaymentHistory } from "Pages/PaymentHistory";
import { MainPage } from "Pages/main";
import { useProtectRoutes } from "Shared/hooks/lib/useProtectRoutes";
import { ErrorFallback } from "Shared/ui";
import {
	AboutAppText,
	CancellationPolicyText,
	PrivacyPolicyText,
	TermsAndConditionsText,
	UserAgreementsText,
} from "Shared/bigTexts";

function App() {
	useProtectRoutes();
	return (
		<div className="app">
			<div className="app_mask">
				<ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
					<Routes>
						<Route path="/" element={<CheckUserPage />} />
						<Route path="/main" element={<MainPage />}>
							<Route path="about" element={<AboutApplicationPage />}>
								<Route path="app" element={<AboutAppText />} />
								<Route path="terms" element={<TermsAndConditionsText />} />
								<Route path="privacy" element={<PrivacyPolicyText />} />
								<Route path="agreement" element={<UserAgreementsText />} />
								<Route path="cancellation" element={<CancellationPolicyText />} />
							</Route>
							<Route path="withdraw" element={<WithdrawPage />} />
							<Route path="p-history" element={<PaymentHistory />} />
						</Route>
						<Route path="/auth/*" element={<AuthRouter />} />
					</Routes>
				</ErrorBoundary>
			</div>
		</div>
	);
}

export default App;
